module.exports = __webpack_public_path__ + "static/media/build-code-icon.15275ca8.svg";